import { signatureIdDetail } from "./signatureIdReducer";

export const signatureId_action = (query) => async (dispatch) => {
    try {
        dispatch(signatureIdDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};